module.exports = __webpack_public_path__ + "img/yiqu.297f1ba0.jpg";